export default __webpack_public_path__ + "static/media/logo.b3a141f1.png";